import React, { PropsWithChildren } from 'react';
import * as AlertDialog from '@givebutter/primitives/alert-dialog';
import { Button } from '@givebutter/primitives/button';
import { REDUCE_SPAM_COMPLAINTS_HELP_LINK } from 'constants/links';
import { useCurrentEngageMessage } from 'customHooks/useCurrentEngageMessage';

interface FilterWarningProps extends PropsWithChildren {
    onProceed?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}
const FilterWarning = ({ children, onProceed }: FilterWarningProps) => {
    const { data } = useCurrentEngageMessage();
    const isEmail = data.channel === 'email';

    return (
        <AlertDialog.Root>
            {children}
            <AlertDialog.Portal>
                <AlertDialog.Overlay />
                <AlertDialog.Content className="flex max-w-md flex-col gap-4 p-4">
                    <AlertDialog.Close />
                    <div className="text-xl">All Contacts</div>
                    {isEmail ? (
                        <div className="flex flex-col gap-2">
                            <p className="font-bold">
                                Wait! This could hurt your email performance
                            </p>
                            <p>
                                You're about to send this email to all contacts, which can increase
                                spam complaints and bounces. If these rates get too high, your email
                                access could be restricted.
                            </p>
                            <p className="font-bold">To protect your sender reputation:</p>
                            <ul className="list-inside list-disc">
                                <li>Use targeted lists for better engagement.</li>
                                <li>Avoid sending to unverified or inactive contacts.</li>
                            </ul>
                            <p>Do you wish to continue?</p>
                        </div>
                    ) : (
                        <div className="flex flex-col gap-2">
                            <p className="font-bold">
                                You have not selected any filters for your contact list.
                            </p>
                            <p>This message will be sent to all contacts listed.</p>
                            <p>Do you wish to continue?</p>
                        </div>
                    )}

                    <AlertDialog.Footer className="items-center">
                        {isEmail && (
                            <a
                                href={REDUCE_SPAM_COMPLAINTS_HELP_LINK}
                                target="_blank"
                                rel="noreferrer"
                            >
                                Learn more
                            </a>
                        )}
                        <Button variant="solid" onClick={onProceed}>
                            Proceed
                        </Button>
                    </AlertDialog.Footer>
                </AlertDialog.Content>
            </AlertDialog.Portal>
        </AlertDialog.Root>
    );
};

const Root = FilterWarning;
const Trigger = AlertDialog.Trigger;
const FilterWarningTrigger = Trigger;

export {
    Root,
    Trigger,
    //
    FilterWarning,
    FilterWarningTrigger,
};
